import { crudMutations, crudActions } from './modules/action-helpers'

const basePath = 'api/user'

export default {
  namespaced: true,
  basePath: basePath,
  state: {
    items: [],
    count: 0,
    currentPage: 1,
    currentItem: null
  },
  mutations: {
    ...crudMutations()
  },
  actions: {
    ...crudActions({ basePath: basePath }),
    async save ({ dispatch, state }, data) {
      return dispatch('save', { basePath: `${basePath}/add_user`, data: data }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async modify ({ dispatch, state }, data) {
      return dispatch('patch', { basePath: `${basePath}/change_user`, data: {user: {roles: data.roles}}, id: data.user.id }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.items }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js